export default {
  title: 'Anmodninger om datasletning',
  fields: {
    created_at: 'Anmodet den',
    restaurant: 'Restaurant',
    customer: 'Kunde',
    note: 'Note',
    status: 'Status',
    completed_by: 'Gennemført af',
    actions: 'Handlinger',
  },
  statuses: {
    pending: 'Afventer',
    completed: 'Gennemført',
  },
  buttons: {
    approve: 'Godkend',
  },
  modals: {
    approve: {
      title: 'Godkend datasletning for {{name}}?',
      description:
        'Dette sletter kundens personoplysninger permanent og kan ikke fortrydes. Anmodningen markeres som gennemført.',
    },
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses',
    failed_to_approve: 'Anmodningen kunne ikke godkendes',
    approved: 'Anmodning godkendt og data slettet',
  },
};
